import { ActionType, createAction } from 'typesafe-actions'

import { AuthAction } from './auth/actions'
import { UserGroupAction } from './userGroups/actions'
import { UserAction } from './user/actions'

export const serverFailure = createAction('/data/SERVER_FAILURE')

export type DataAction = AuthAction | UserAction | UserGroupAction | ActionType<typeof serverFailure>
